import { Component, OnInit } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AttributionDao } from '@app/dao/attribution/attribution.dao';
import { UserDao } from '@app/dao/user/user.dao';
import { take } from 'rxjs';

@Component({
    selector: 'ea-simulation-bottom-sheet',
    templateUrl: './ea-simulation-bottom-sheet.component.html',
    styleUrls: ['./ea-simulation-bottom-sheet.component.scss'],
    standalone: false
})
export class EaSimulationBottomSheetComponent implements OnInit {
  menus = {
    label: 'Product',
    items: [
      {
        label: 'SCPI',
        url: '/dashboard/sheets/simulation/scpi',
      },
      {
        label: 'Assurance vie',
        url: '/dashboard/sheets/simulation/av',
      },
      {
        label: 'GIRARDIN',
        url: '/dashboard/sheets/simulation/girardin',
      },
      // {
      //   label: 'PINEL',
      //   url: '/dashboard/sheets/simulation/pinel',
      // },
      {
        label: 'FCPI',
        url: '/dashboard/sheets/simulation/fcpi',
      },
      {
        label: 'PER',
        url: '/dashboard/sheets/simulation/per',
      },
      {
        label: 'FIP',
        url: '/dashboard/sheets/simulation/fip',
      },
      {
        label: 'Private Equity',
        url: '/dashboard/sheets/simulation/pme',
      },
      {
        label: 'SOFICA',
        url: '/dashboard/sheets/simulation/sofica',
      },
      {
        label: 'LMNP',
        url: '/dashboard/sheets/simulation/lmnp',
      },
    ],
  };

  CristalisOrganizationId: number = 251251251;

  constructor(
    private _bottomSheetRef: MatBottomSheetRef<EaSimulationBottomSheetComponent>,
    public dialog: MatDialog,
    private router: Router,
    public userDao: UserDao,
    private attributionDao: AttributionDao,
  ) {}

  ngOnInit(): void {
    this.attributionDao
      .getOrganization()
      .pipe(take(1))
      .subscribe((data: any) => {
        if (data.id === this.CristalisOrganizationId) {
          this.menus.items.push({
            label: 'FISCALITE IMMOBILIERE',
            url: '/dashboard/sheets/simulation/fiscality-rent',
          });
        }
      });
  }

  openLink(event: MouseEvent, option: { url: string }): void {
    this.router.navigate([option.url]);
    this._bottomSheetRef.dismiss();
    event.preventDefault();
  }
}
